import { render } from "./HandymanOrderDetail.vue?vue&type=template&id=41546cc2"
import script from "./HandymanOrderDetail.vue?vue&type=script&lang=js"
export * from "./HandymanOrderDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__